import { OPTIONS_INTEGRATION } from 'app-constants'
import { http } from 'hooks'

export function messagesService() {
  function getMessages(contractId) {
    return http.get('v3/messages', { ...OPTIONS_INTEGRATION, params: { contractId } })
  }

  function updateMessages(id) {
    return http.patch(`v1/messages/${id}`, {}, OPTIONS_INTEGRATION)
  }

  function deleteMessages(id) {
    return http.delete(`v1/messages/${id}`, OPTIONS_INTEGRATION)
  }

  function sendContractWithdrawal(messageId) {
    return http.post(`/v1/messages/${messageId}/contact-withdrawal`, {}, OPTIONS_INTEGRATION)
  }

  function readAllMessages() {
    return http.patch(`v1/messages/read-all`, {}, OPTIONS_INTEGRATION)
  }

  return {
    getMessages,
    updateMessages,
    deleteMessages,
    sendContractWithdrawal,
    readAllMessages,
  }
}
